/* unplugin-vue-components disabled */import script from "./kfToggleDia.vue?vue&type=script&setup=true&lang=js"
export * from "./kfToggleDia.vue?vue&type=script&setup=true&lang=js"

import "./kfToggleDia.vue?vue&type=style&index=0&id=b7afcc46&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7afcc46"]])

export default __exports__